import { Component, Input, Output, EventEmitter, OnChanges, ViewChild } from '@angular/core';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { AfTranslateDirective } from '../../modules/translate/directive/af-translate.directive';
import { FormsModule } from '@angular/forms';
import { NgClass, NgStyle } from '@angular/common';
import { ColorPicker, ColorPickerModule } from 'primeng/colorpicker';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { TooltipInfoComponent } from "../tooltip-info/tooltip-info.component";

@Component({
    selector: 'field-type-color',
    templateUrl: './field-type-color.component.html',
    standalone: true,
    imports: [NgClass, NgStyle, FormsModule, AfTranslateDirective, ColorPickerModule, TooltipInfoComponent]
})

export class FieldTypeColorComponent implements OnChanges {
  fieldTypeColor: any = {
    fieldId: this.commonUtilsService.createId(),
    companyColorSelected: '',
    companyColorSelectedInput: null,
    noEditable: false,
    placeholder: '#000000'
  }
  constructor(private commonUtilsService: CommonUtilsService,
    private translate: AfTranslateFactory) { }
  @Input() preSelectItem: any = {};
  @Input() field: any = {};
  @Output() itemSelectedEmit = new EventEmitter();
  @ViewChild('fieldTypeColorPicker') colorPicker: ColorPicker;

  ngOnChanges():void{
    if(this.field) {
      this.fieldTypeColor.field = this.field;
      this.fieldTypeColor.titleField = this.field.extendedLabel && this.field.extendedLabel !== ''? this.field.extendedLabel : this.field.label;
      if(!this.preSelectItem || this.preSelectItem === null){
        this.fieldTypeColor.companyColorSelected = '';
      }else{
        this.fieldTypeColor.companyColorSelected = this.preSelectItem;
      }
    }
  }

  resetText(){
    this.fieldTypeColor.companyColorSelected = '';
    this.emitColor();
  }

  openColorPicker(){
    this.colorPicker.onInputClick();
  }

  changeColor(e: any){
    this.fieldTypeColor.companyColorSelected = e.value;
    this.emitColor();
  }

  blurInput(){
    if(this.fieldTypeColor.companyColorSelected){
      if(this.fieldTypeColor.companyColorSelected.indexOf('#') === -1){
        this.fieldTypeColor.companyColorSelected = '#' + this.fieldTypeColor.companyColorSelected;
      }
      if(this.fieldTypeColor.companyColorSelected.length === 4){
        let listElements: any = this.fieldTypeColor.companyColorSelected.split('');
        let companyColorSelected: string = '#';
        for (let i = 1; i < listElements.length; i++) {
          companyColorSelected += listElements[i]+listElements[i];
        }
        this.fieldTypeColor.companyColorSelected = companyColorSelected;
      }else if(this.fieldTypeColor.companyColorSelected.length > 7){
        this.fieldTypeColor.companyColorSelected = this.fieldTypeColor.companyColorSelected.substring(0, 7);
      }else if(this.fieldTypeColor.companyColorSelected.length < 7){
        let diffText: number = 7 - this.fieldTypeColor.companyColorSelected.length;
        for (let i = 0; i < diffText; i++) {
          this.fieldTypeColor.companyColorSelected += '0';
        }
      }
      if(this.commonUtilsService.checkIsHexadecimalColor(this.fieldTypeColor.companyColorSelected)){
        this.emitColor();
      }else{
        this.field.errorText = this.translate.instant('field-type-color.error-hex-color');
        this.field.error = true;
      }
    }
  }

  emitColor(){
    delete this.field.errorText;
    this.field.error = false;
    this.itemSelectedEmit.emit({ newValue: this.fieldTypeColor.companyColorSelected });
  }
}
